export default {
    PENDING: 'bg-yellow-500',
    IN_PREPARATION: 'bg-orange-500',
    READY: 'bg-blue-500',
    ON_THE_WAY: 'bg-purple-500',
    DELIVERED: 'bg-green-500',
    CLOSED: 'bg-black',
    CANCELLED: 'bg-red-500',
}